import { Button, FileButton } from "@mantine/core";
import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";

export default function FileUploaderWithoutPreview({ form, title, formId, fileId }) {
  const [isUploading, setIsUploading] = useState(false);

  async function handleFileUpload(file) {
    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append("files", file);
      const { data } = await axios({
        method: "POST",
        url: "/upload",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(data[0].id);
      form.setFieldValue(formId, data[0].id);
    } catch (error) {
      console.error(error);
      toast.error("파일 업로드 실패. 잠시 후 다시 시도해주세요");
    } finally {
      setIsUploading(false);
    }
  }

  return (
    <FileButton
      onChange={handleFileUpload}
      accept="image/png,image/jpeg,application/pdf"
      loading={isUploading}
    >
      {(props) => (
        <Button
          style={{ flex: 1 }}
          variant={fileId ? "filled" : "light"}
          color={fileId ? "teal" : "brand"}
          {...props}
        >
          {title}
        </Button>
      )}
    </FileButton>
  );
}
